module.exports = __webpack_public_path__ + "media/images/metronic/social/github-b81e42fc304e3b5443e2e1bea54e7da3.png";